import { render, staticRenderFns } from "./ShopStepper.vue?vue&type=template&id=18a9b484"
import script from "./ShopStepper.vue?vue&type=script&lang=js"
export * from "./ShopStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports